import { Injectable } from '@angular/core';
import { AsyncSubject } from 'rxjs';
import { AS_COMPLETE, COMPRESS_IMAGE_FILE, FILES_TO_SCAN } from './ngx-scanner-qrcode.helper';
import { ScannerQRCodeConfig, ScannerQRCodeSelectedFiles } from './ngx-scanner-qrcode.options';

@Injectable({
  providedIn: 'root'
})
export class NgxScannerQrcodeService {

  /**
   * loadFiles
   * @param files 
   * @param percentage 
   * @param quality 
   * @returns 
   */
  public loadFiles(files: File[] = [], percentage?: number, quality?: number): AsyncSubject<ScannerQRCodeSelectedFiles[]> {
    const as = new AsyncSubject<ScannerQRCodeSelectedFiles[]>();
    COMPRESS_IMAGE_FILE(files, percentage, quality).then((_files: File[]) => {
      Promise.all(Object.assign([], _files).map((m: File) => this.readAsDataURL(m))).then((img: ScannerQRCodeSelectedFiles[]) => AS_COMPLETE(as, img)).catch((error: any) => AS_COMPLETE(as, null, error));
    });
    return as;
  }

  /**
   * loadFilesToScan
   * @param files 
   * @param config 
   * @param percentage 
   * @param quality 
   * @returns 
   */
  public loadFilesToScan(files: File[] = [], config: ScannerQRCodeConfig, percentage?: number, quality?: number): AsyncSubject<ScannerQRCodeSelectedFiles[]> {
    return FILES_TO_SCAN(files, config, percentage, quality);
  }

  /**
   * readAsDataURL
   * @param file 
   * @returns 
   */
  private readAsDataURL(file: File): Promise<ScannerQRCodeSelectedFiles> {
    /** drawImage **/
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        const objectFile = {
          name: file.name,
          file: file,
          url: URL.createObjectURL(file)
        };
        resolve(objectFile);
      }
      fileReader.onerror = (error: any) => reject(error);
      fileReader.readAsDataURL(file);
    })
  }
}